import { Loader, type LoaderProps, Box, type BoxProps, LoadingOverlay } from "@mantine/core";
import "./InlineLoading.scss";

import clsx from "clsx";
import * as React from "react";

/**
 * Defines the inputs accepted by this layout component.
 */
interface IInlineLoadingProps {
    size?: LoaderProps["size"];
    text?: string;
    height?: BoxProps["h"];
    boxProps?: BoxProps;
}

/**
 * Displays loading bars inline or in a positioned overlay when height is truthy.
 *
 * Postconditions: With a height, box props are applied to both boxes; otherwise only their class
 * name is used on the loader box. The size prop supplies the vertical margin, not Loader.size.
 */
class InlineLoading extends React.Component<IInlineLoadingProps, any> {
    /**
     * Builds the loading presentation from the current props without managing task state.
     */
    render() {
        const { size = "md", text, height, boxProps } = this.props;

        const loaderBoxProps = height ? boxProps : {};

        const loader = (
            <Box
                {...loaderBoxProps}
                className={clsx("inline-loading", boxProps?.className)}
            >
                <Loader
                    mx="auto"
                    my={size}
                    color="secondary"
                    type="bars"
                />
                {text}
            </Box>
        );

        if (height) {
            return (
                <Box
                    pos="relative"
                    h={height}
                    {...boxProps}
                >
                    <LoadingOverlay
                        visible={true}
                        zIndex={1000}
                        loaderProps={{
                            children: loader
                        }}
                    />
                </Box>
            );
        }

        return loader;
    }
}
export default InlineLoading;
